export default "__VITE_ASSET__DdEgDoLH__"